import PropTypes from 'prop-types';
import React, { Fragment, PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import { getProjectComparisionData } from '../../apis';
import ComparisionSummary from '../../components/ComparisionSummary';
import ComparisionTable from '../../components/ComparisionTable';
import Pagebreak from '../../components/Pagebreak';
import WelcomeScreen from '../../components/WelcomeScreen';
import Error from '../Error';
import './quote.css';


class Home extends PureComponent {
  static defaultProps = {
    match: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      error: false,
      errorMessage: null,
      project: {
        rooms: [],
      },
    };
  }

  componentDidMount() {
    const {
      match: {
        params: { projectId, versionCurrent, versionOld },
      },
    } = this.props;

    getProjectComparisionData({
      versionCurrent,
      projectId,
      versionOld,
    })
      .then((data) => {
        if (data.status === 'error') {
          throw new Error(data.message);
        }
        this.setState({
          project: data.data,
        });
      })
      .catch(({ props }) => {
        // console.log(e);
        this.setState({
          error: true,
          errorMessage: props,
        });
      });
  }

  render() {
    const { project, error, errorMessage } = this.state;
    const {
      match: {
        params: { versionCurrent, versionOld },
      },
    } = this.props;
    const { summary, customerData } = project;
    return !error ? (
      <Fragment>
        <Helmet>
          <title>Quote Compare</title>
        </Helmet>
        <WelcomeScreen
          customerData={customerData}
          summary={summary}
          versions={{
            versionCurrent,
            versionOld,
          }}
        />
        <br />
        <br />
        <br />
        <br />
        <Pagebreak />
        <ComparisionSummary summaryData={summary} />
        <Pagebreak />
        <ComparisionTable
          project={project}
          versions={{
            versionCurrent,
            versionOld,
          }}
        />
      </Fragment>
    ) : (
      <Error errorMessage={errorMessage} />
    );
  }
}

Home.propTypes = {
  match: PropTypes.object,
};


export default Home;



// WEBPACK FOOTER //
// ./src/containers/CompareProject/index.js